var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "gantt-elastic",
    {
      attrs: {
        tasks: _vm.tasks,
        options: _vm.options,
        dynamicStyle: _vm.dynamicStyle
      }
    },
    [
      _vm.components.header
        ? _c(_vm.components.header, {
            tag: "component",
            attrs: { slot: "header", options: { slots: { header: {} } } },
            slot: "header"
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.components.footer
        ? _c(_vm.components.footer, {
            tag: "component",
            attrs: { slot: "footer" },
            slot: "footer"
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }